/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import libheif from "libheif-js"

export const convertHEICToImageData = async (buffer: ArrayBuffer): Promise<ImageData> => {
	await libheif.ready

	const decoder = new libheif.HeifDecoder()
	const data = decoder.decode(buffer)
	const image = await decodeImage(data[0])

	const pixelView = new Uint8ClampedArray(
		image.data.buffer as ArrayBuffer,
		image.data.byteOffset,
		image.data.byteLength,
	)

	return new ImageData(pixelView, image.width, image.height)
}

const decodeImage = async (image) => {
	const width = image.get_width()
	const height = image.get_height()

	const { data } = await new Promise<{ data: Uint8ClampedArray }>((resolve, reject) => {
		image.display(
			{ data: new Uint8ClampedArray(width * height * 4), width, height },
			(displayData) => {
				if (!displayData) {
					return reject(new Error("HEIF processing error"))
				}

				resolve(displayData)
			},
		)
	})

	return { width, height, data }
}
